__turbopack_context__.v({
  "mobile_fullscreen_chat": "chat-widget-module-scss-module__5dsIPG__mobile_fullscreen_chat",
  "root": "chat-widget-module-scss-module__5dsIPG__root",
  "wrap": "chat-widget-module-scss-module__5dsIPG__wrap",
  "wrap_content": "chat-widget-module-scss-module__5dsIPG__wrap_content",
});
